import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/check.svg'
import _imports_1 from '@/assets/icons/arrow-right-up.svg'


const _withScopeId = n => (_pushScopeId("data-v-11c52890"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.nomad.xyz/token-bridge/how-to-bridge#completing-a-transfer-ethereum-destination-only",
  target: "_blank",
  class: "underline"
}, " Read more ", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Good news! Transfers to ")
const _hoisted_3 = { class: "capitalize" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" are subsidized, so funds will be deposited in your account automatically once bridging is complete. ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.nomad.xyz/token-bridge/how-to-bridge",
  target: "_blank",
  class: "underline"
}, " Read more ", -1 /* HOISTED */))
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col items-center"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Loading . . .")
const _hoisted_8 = { class: "flex flex-col items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "check",
  class: "mb-2"
}, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Transfer complete")
const _hoisted_11 = { class: "flex flex-col items-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Status not available")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Check your wallet after the 35-60 minute window to see if funds have arrived. ")
const _hoisted_14 = { class: "flex flex-col items-center" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Status not available")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" You may safely try to complete your transaction by clicking below. Note that you should wait at least 35 minutes after your transfer was sent. ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "click-me flex flex-row items-center" }, [
  /*#__PURE__*/_createTextVNode(" Complete transfer "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "open",
    class: "ml-2 cursor-pointer"
  })
], -1 /* HOISTED */))
const _hoisted_18 = { class: "flex flex-col items-center max-w-xs" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "click-me flex flex-row items-center" }, [
  /*#__PURE__*/_createTextVNode(" Complete transfer "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "open",
    class: "ml-2 cursor-pointer"
  })
], -1 /* HOISTED */))
const _hoisted_20 = { class: "flex flex-col items-center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Est. time remaining")
const _hoisted_25 = {
  key: 0,
  class: "flex flex-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_circle_outline = _resolveComponent("alert-circle-outline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_ChevronDown = _resolveComponent("ChevronDown")!
  const _component_n_step = _resolveComponent("n-step")!
  const _component_n_progress = _resolveComponent("n-progress")!
  const _component_n_steps = _resolveComponent("n-steps")!
  const _component_n_collapse_transition = _resolveComponent("n-collapse-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Return to process "),
    (!_ctx.readyToManualProcess && _ctx.requiresManualProcessing && _ctx.showAlerts)
      ? (_openBlock(), _createBlock(_component_n_alert, {
          key: 0,
          title: "Transfer pending",
          type: "default",
          class: "mb-5 rounded-md"
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_n_icon, { color: "#3889c5" }, {
              default: _withCtx(() => [
                _createVNode(_component_alert_circle_outline)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" Return to this page once bridging is complete to collect your funds on " + _toDisplayString(_ctx.getDisplayName(_ctx.destinationNetwork)) + ". ", 1 /* TEXT */),
            _hoisted_1
          ]),
          _: 1 /* STABLE */
        }))
      : (!_ctx.requiresManualProcessing && _ctx.showAlerts)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" Processing is subsidized "),
            _createVNode(_component_n_alert, {
              title: "Transfer pending",
              type: "default",
              class: "mb-5 rounded-md"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, { color: "#3889c5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_alert_circle_outline)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.destinationNetwork), 1 /* TEXT */),
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1 /* STABLE */
            })
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["header transition-all duration-400 px-5 py-8", [_ctx.transferComplete ? 'bg-[#2fbb72]' : 'bg-[#5185d0]']])
    }, [
      _createCommentVNode(" loading "),
      (!_ctx.statusAvailable)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createVNode(_component_n_spin, {
              stroke: "#fff",
              class: "mb-3"
            }),
            _createVNode(_component_n_text, { class: "uppercase opacity-60" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : (_ctx.transferComplete)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" complete "),
              _createElementVNode("span", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_n_text, { class: "uppercase opacity-80" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_ctx.status === -1 && !_ctx.requiresManualProcessing)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createCommentVNode(" status not available, subsidized network "),
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_n_text, { class: "text-3xl mb-2" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_n_text, { class: "opacity-80 text-center" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : (_ctx.status === -1 && _ctx.requiresManualProcessing)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createCommentVNode(" status not available, subsidized network "),
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_n_text, { class: "text-3xl mb-2" }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_n_text, { class: "opacity-80 text-center mb-2" }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_n_text, {
                      onClick: _ctx.processTx,
                      class: "uppercase mt-1 cursor-pointer p-2"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : (_ctx.readyToManualProcess)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createCommentVNode(" Manual process "),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_n_text, { class: "mb-2 opacity-80 text-center" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Your funds have been bridged back to " + _toDisplayString(_ctx.getDisplayName(_ctx.destinationNetwork)) + "! Please click below to submit a transaction to complete your transfer. ", 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_n_text, {
                        onClick: _ctx.processTx,
                        class: "uppercase mt-1 cursor-pointer p-2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"])
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createCommentVNode(" in progress "),
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_n_text, { class: "text-4xl mb-2" }, {
                        default: _withCtx(() => [
                          (!_ctx.minutesRemaining)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                            : (_ctx.minutesRemaining <= _ctx.PROCESS_TIME_IN_MINUTES)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Less than " + _toDisplayString(_ctx.PROCESS_TIME_IN_MINUTES) + " minutes ", 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.minutesRemaining) + " minutes", 1 /* TEXT */))
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_n_text, { class: "uppercase opacity-60" }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createCommentVNode(" dropdown status stepper "),
                      _createElementVNode("div", {
                        class: "px-8 py-1 mt-4 cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showStatus = !_ctx.showStatus))
                      }, [
                        _createVNode(_component_n_icon, { size: "16" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ChevronDown, {
                              class: _normalizeClass(["transition-all", { 'rotate-180': _ctx.showStatus }])
                            }, null, 8 /* PROPS */, ["class"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_n_collapse_transition, { show: _ctx.showStatus }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_steps, {
                              vertical: "",
                              current: _ctx.stepperStatus,
                              size: "small",
                              class: "mt-2 px-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_n_step, {
                                  value: "0",
                                  title: "Dispatched"
                                }),
                                _createVNode(_component_n_step, {
                                  value: "1",
                                  title: "Included"
                                }),
                                _createVNode(_component_n_step, {
                                  value: "2",
                                  title: "Relayed"
                                }),
                                _createVNode(_component_n_step, {
                                  value: "3",
                                  title: "Confirmation Time"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.status === 2 && _ctx.minutesRemaining)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          _createVNode(_component_n_progress, {
                                            type: "line",
                                            color: "#fff",
                                            "rail-color": "rgba(255, 255, 255, 0.5",
                                            percentage: _ctx.confirmationProgress,
                                            "indicator-text-color": "#fff"
                                          }, null, 8 /* PROPS */, ["percentage"])
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_n_step, {
                                  value: "4",
                                  title: "Processed"
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["current"])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["show"])
                      ])
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}